import { Component, OnInit } from "@angular/core";
import { ReportService } from "../report.service";
import { UserService } from "../../../shared";

@Component({
	selector: "app-parent-portal-all-users",
	templateUrl: "./parent-portal-all-users.component.html",
	styleUrls: ["./parent-portal-all-users.component.css"],
})
export class ParentPortalAllUsersComponent implements OnInit {
	constructor(
		private userService: UserService,
		// private selectService: SchoolselectorService,
		private reportService: ReportService //Insert Custom Services Here // private dialogService: DialogService
	) {}
	report = {
		SortByID: "ParentFirstName",
		SortDirectionID: "ASC",
		ImageLogo: "",
		SchoolID: 0,
	};

	//Insert Custom Lists Here
	ImageLogoList: any = [];

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	SortByList = [
		{
			ID: "ParentFirstName",
			Desc: "Parent First Name",
		},
		{
			ID: "ParentLastName",
			Desc: "Parent Last Name",
		},
		{
			ID: "Email",
			Desc: "Email",
		},
		{
			ID: "Language",
			Desc: "Language",
		},
	];

	SortDirectionList = [
		{
			ID: "ASC",
			Desc: "Ascending",
		},
		{
			ID: "DESC",
			Desc: "Descending",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 469;

	ngOnInit() {
		this.user = this.userService.getCurrentUser();
		this.loadLogolist();
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", 0);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var result = this.reportService.Print(this.ReportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: UserID
		strParam += this.user.userID + "|UserID";

		//Parameter 2: SortBy
		strParam += "," + this.report.SortByID + "|SortBy";

		//Parameter 3: SortDirection
		strParam += "," + this.report.SortDirectionID + "|SortDirection";

		//Parameter 4: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	// MergeToGroup() {
	// 	this.errorMessage = "";

	// 	this.isProcessing = true;
	// 	var strParam = this.GetStrParam();

	// 	var parms: MergeToGroupRequest = {
	// 		ReportID: this.ReportID,
	// 		SchoolID: this.report.SchoolID,
	// 		strParms: strParam,
	// 	};

	// 	var result = this.reportService.MergeToGroupSelectInfo(parms);
	// 	result.subscribe(
	// 		(response: any) => {
	// 			if (response.length > 0) {
	// 				var ref = this.dialogService.open(MergeToGroupDialogComponent, {
	// 					header: "Merge to Group",
	// 					width: "fit-content",
	// 					data: {
	// 						//INSERT Custom Data here
	// 						lstPerson: response,
	// 						SchoolID: this.report.SchoolID,
	// 					},
	// 				});
	// 				ref.onClose.subscribe((response) => {
	// 					if (response == 1) {
	// 					}
	// 				});
	// 			} else {
	// 				this.errorMessage = "No Data available";
	// 			}

	// 			this.isProcessing = false;
	// 		},
	// 		(error) => {
	// 			this.errorMessage = error;
	// 			this.isProcessing = false;
	// 		}
	// 	);
	// }
}
